/**
 * Air conditioner icon component
 */
export function AirConditionerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
      <g clipPath="url(#clip0_4875_4321)">
        <path
          d="M15.3335 30.6665C15.3335 32.1915 14.7277 33.654 13.6494 34.7324C12.571 35.8107 11.1085 36.4165 9.5835 36.4165"
          stroke="#A990C9"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.6665 30.6665C30.6665 32.1915 31.2723 33.654 32.3506 34.7324C33.429 35.8107 34.8915 36.4165 36.4165 36.4165"
          stroke="#A990C9"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M23 30.6665V38.3332" stroke="#A990C9" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M5.75 13.4168C5.75 12.4002 6.15387 11.4251 6.87276 10.7063C7.59165 9.98736 8.56667 9.5835 9.58333 9.5835H36.4167C37.4333 9.5835 38.4084 9.98736 39.1272 10.7063C39.8461 11.4251 40.25 12.4002 40.25 13.4168V21.0835C40.25 22.1002 39.8461 23.0752 39.1272 23.7941C38.4084 24.513 37.4333 24.9168 36.4167 24.9168H9.58333C8.56667 24.9168 7.59165 24.513 6.87276 23.7941C6.15387 23.0752 5.75 22.1002 5.75 21.0835V13.4168Z"
          stroke="#A990C9"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4165 24.9167V19.1667C13.4165 18.6583 13.6184 18.1708 13.9779 17.8114C14.3373 17.4519 14.8248 17.25 15.3332 17.25H30.6665C31.1748 17.25 31.6623 17.4519 32.0218 17.8114C32.3812 18.1708 32.5832 18.6583 32.5832 19.1667V24.9167"
          stroke="#A990C9"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4875_4321">
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
